export default [
	'course',
	'guide',
	'guideTemplate',
	'interactiveText',
	'styleSheet',
	'interactiveSlide',
	'lessonPlan',
	'smartLesson',
	'assessment'
];